import { NavLink } from 'react-router-dom';
import {
    Collapse,
    List,
    ListItem,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { withTranslation } from 'react-i18next';
import { isEnoughPermissions } from '../../utils';

const styles = theme => ({
    button: {
        '&.active': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)'
        }
    },
    nested: {
        paddingLeft: theme.spacing(6),
    },
    nestedRoute: {
        display: 'flex',
        justifyContent: 'space-between'
    },
});

const AdapterNavLink = React.forwardRef((props, ref) => (
    <NavLink
        ref={ref}
        {...props}
    />
));

const menuItems = [
    { translateId: 'generalCategories', routeTo: '/admin/general-categories' },
    { translateId: 'deviceTypes', routeTo: '/admin/device' },
    { translateId: 'deviceManufacturers', routeTo: '/admin/device-manufacturer' },
    { translateId: 'deviceAssignmentReasons', routeTo: '/admin/device-assignment-reasons' },
    { translateId: 'mobileDeviceTypes', routeTo: '/admin/mobile-device' },
    { translateId: 'mobileVersions', routeTo: '/admin/mobile-versions' },
    { translateId: 'licenseManufacturers', routeTo: '/admin/manufacturers' },
    { translateId: 'licenseTitle',
        routeTo: '/admin/title-license',
        childrenRoutes: [
            { translateId: 'licenseProductName', routeTo: '/admin/title-license/product-name' },
            { translateId: 'licenseProductVersion', routeTo: '/admin/title-license/product-version' },
            { translateId: 'licenseProductAttribute', routeTo: '/admin/title-license/product-attribute' },
        ] },
    { translateId: 'rolesAndPermissions', routeTo: '/admin/permissions' },
    { translateId: 'settings',
        routeTo: '/admin/settings',
        childrenRoutes: [
            { translateId: 'licenses', routeTo: '/admin/settings/licenses' },
        ] },

];

class DrawerAdminPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            licenseTitle: false,
            settings: false

        };

    }

    handleClick = name => {
        this.setState(state => ({
            ...state,
            [name]: !this.state[name],
        }));
    }

    render() {
        const { classes, model, t } = this.props;

        const currentUserPerms = model ? model.permissions : [];
        const filteredMenuItems = menuItems.filter(item => isEnoughPermissions(item, currentUserPerms));

        return (
            <List>
                {filteredMenuItems.map(item => {

                    if (item.childrenRoutes) {
                        return (
                            <React.Fragment key={`${filteredMenuItems.indexOf(item)}+${item.translateId}`}>
                                <ListItem
                                    button
                                    className={`${classes.button} ${classes.nestedRoute}`}
                                    onClick={() => { this.handleClick(item.translateId); }}
                                >
                                    {t(item.translateId)}

                                    {this.state[item.translateId] ? <ExpandLess /> : <ExpandMore />}
                                </ListItem>

                                <Collapse
                                    component="li"
                                    in={this.state[item.translateId]}
                                    timeout="auto"
                                    unmountOnExit
                                >
                                    {item.childrenRoutes.map(el => (
                                        <List
                                            disablePadding
                                            key={`${item.childrenRoutes.indexOf(el)} ${el.translateId}`}
                                        >
                                            <ListItem
                                                button
                                                className={`${classes.button} ${classes.nested}`}
                                                component={AdapterNavLink}
                                                to={el.routeTo}
                                            >
                                                {t(el.translateId)}
                                            </ListItem>
                                        </List>

                                    ))}
                                </Collapse>

                            </React.Fragment>
                        );

                    } else {
                        return (
                            <ListItem
                                key={filteredMenuItems.indexOf(item)}
                                button
                                className={classes.button}
                                component={AdapterNavLink}
                                to={item.routeTo}
                            >
                                {t(item.translateId)}
                            </ListItem>
                        );
                    }
                })}
            </List>
        );
    }

}

DrawerAdminPanel.propTypes = {
    classes: PropTypes.shape({
        button: PropTypes.string,
    }),
    model: PropTypes.shape({
        permissions: PropTypes.arrayOf(PropTypes.string),
    }),
};

const mapStateToProps = ({ user }) => ({
    model: user.model
});

export default compose(withTranslation('global'), connect(mapStateToProps), withStyles(styles))(DrawerAdminPanel);
